import { useState } from 'react';
import CoachReport from './CoachReport';
import MdpScheduleGrid from './MdpScheduleGrid';

// Coach Reports wrapper with sub-tabs (Production Overview + MDP Schedule)
function CoachReportsWrapper({ onNavigateToPlanning }) {
  const [subTab, setSubTab] = useState('overview');
  const tabs = [
    { id: 'overview', label: 'Production Overview' },
    { id: 'schedule', label: 'MDP Schedule' },
  ];
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1 w-fit">
        {tabs.map(t => (
          <button key={t.id} onClick={() => setSubTab(t.id)}
            className={`px-4 py-2 rounded-md text-sm font-semibold transition-all ${subTab === t.id ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}
            data-testid={`coach-tab-${t.id}`}>
            {t.label}
          </button>
        ))}
      </div>
      {subTab === 'overview' && <CoachReport category="Coach" onNavigateToPlanning={onNavigateToPlanning} />}
      {subTab === 'schedule' && <MdpScheduleGrid category="Coach" />}
    </div>
  );
}

export default CoachReportsWrapper;
